<div class="view-quiz-question text-14 mb-8" *ngIf="question" data-test="question">
    <div class="view-quiz-question__prompt mb-4" data-test="questionPrompt">
        <app-content-blocks [contentBlocks]="question.questionPrompt"></app-content-blocks>
    </div>

    <div [ngSwitch]="question.type">

        <!-- Multiple Choice -->
        <div *ngSwitchCase="QuestionType.MultipleChoice">
            <mat-radio-group class="flex flex-column" (change)="handleMultipleChoiceChange($event)">
                <mat-radio-button
                    data-test="questionAnswer"
                    class="view-quiz-question__option"
                    *ngFor="let option of question.data.options"
                    [value]="option.value">
                    {{ option.label }}
                </mat-radio-button>
            </mat-radio-group>
        </div>

        <!-- Select Anatomy -->
        <div *ngSwitchCase="QuestionType.SelectAnatomy">
            <div *ngIf="question.data.showAnswerList" class="ml-3">
                <app-view-quiz-object-tree [objectIds]="question.data.correctAnswer">                    
                </app-view-quiz-object-tree>
            </div>
        </div>

        <!-- Label Anatomy -->
        <div *ngSwitchCase="QuestionType.LabelAnatomy">
            <app-view-quiz-label-anatomy (valueChange)="handleLabelAnatomyChanges($event)" [options]="question.data.options">
            </app-view-quiz-label-anatomy>
        </div>

    </div>
</div>